var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCashOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 55.9 33.5",
    style: {
      enableBackground: "new 0 0 55.9 33.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#E98832;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_520",
    className: "st0",
    d: "M55.1,33.5H0.8c-0.4,0-0.8-0.4-0.8-0.8V0.8C0,0.4,0.4,0,0.8,0l0,0h54.3c0.4,0,0.8,0.4,0.8,0.8 v31.9C55.9,33.2,55.5,33.5,55.1,33.5z M1.6,31.9h52.7V1.6H1.6V31.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_521",
    className: "st0",
    d: "M47.1,28.7H8.8c-0.4,0-0.8-0.4-0.8-0.8c0-1.3-1.1-2.4-2.4-2.4h0c-0.4,0-0.8-0.4-0.8-0.8v-16 C4.8,8.3,5.1,8,5.6,8C6.9,8,8,6.9,8,5.6c0-0.4,0.4-0.8,0.8-0.8h38.3c0.4,0,0.8,0.4,0.8,0.8C47.9,6.9,49,8,50.3,8l0,0 c0.4,0,0.8,0.4,0.8,0.8v16c0,0.4-0.4,0.8-0.8,0.8c-1.3,0-2.4,1.1-2.4,2.4v0C47.9,28.4,47.5,28.7,47.1,28.7z M9.5,27.1h36.9 c0.3-1.6,1.5-2.8,3.1-3.1V9.5c-1.6-0.3-2.8-1.5-3.1-3.1H9.5C9.2,8,8,9.2,6.4,9.5V24C8,24.4,9.2,25.6,9.5,27.1L9.5,27.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_522",
    className: "st0",
    d: "M43.9,20c-1.8,0-3.2-1.4-3.2-3.2s1.4-3.2,3.2-3.2s3.2,1.4,3.2,3.2S45.7,20,43.9,20L43.9,20z  M43.9,15.2c-0.9,0-1.6,0.7-1.6,1.6s0.7,1.6,1.6,1.6s1.6-0.7,1.6-1.6v0C45.5,15.9,44.8,15.2,43.9,15.2L43.9,15.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_523",
    className: "st0",
    d: "M12,20c-1.8,0-3.2-1.4-3.2-3.2s1.4-3.2,3.2-3.2s3.2,1.4,3.2,3.2S13.7,20,12,20L12,20z M12,15.2 c-0.9,0-1.6,0.7-1.6,1.6s0.7,1.6,1.6,1.6s1.6-0.7,1.6-1.6l0,0C13.6,15.9,12.9,15.2,12,15.2L12,15.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_524",
    className: "st0",
    d: "M27.9,24c-2.2,0-4-1.8-4-4h1.6c0.1,1.3,1.2,2.3,2.5,2.2c1.2-0.1,2.2-1,2.2-2.2 c0-0.8-0.3-1.7-2.6-2.4c-3.1-0.9-3.8-2.7-3.8-4c0-2.2,1.8-4,4-4s4,1.8,4,4h-1.6c-0.1-1.3-1.2-2.3-2.5-2.2c-1.2,0.1-2.2,1-2.2,2.2 c0,0.4,0,1.6,2.6,2.4c2.5,0.8,3.8,2.1,3.8,4C31.9,22.2,30.1,23.9,27.9,24L27.9,24z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_525",
    className: "st0",
    d: "M27.1,8h1.6v2.4h-1.6V8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_526",
    className: "st0",
    d: "M27.1,23.2h1.6v2.4h-1.6V23.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashOrange);
export default __webpack_public_path__ + "static/media/cash_orange.f459a587bc644d73d39f59017ca22c62.svg";
export { ForwardRef as ReactComponent };